<template lang="pug">
    div
        pie-chart(
            :chart-data="chartData.datacollection"
            :options="chartData.options"
            :width="chartWidth"
            :height="chartHeight")
</template>
<script>
import PieChart from "@/components/pieChart.js";

export default {
    name: "EmptyPie",
    props: {
        chartdata: { type: Object, default: () => {} },
        chartOptions: { type: Object, default: () => {} },
        chartWidth: { type: Number, default: 600 },
        chartHeight: { type: Number, default: 340 },
        chartTitle: { type: String, default: "" },
        useGuage: { type: Boolean, default: false },
        legendDisplay: { type: Boolean, default: true },
        legendPosition: { type: String, default: "top" },
        titleDisplay: { type: Boolean, default: true }
    },
    components: { PieChart },
    watch: {
        chartTitle: function(newVal, oldVal) {
            this.fillChartData();
        }
    },
    created() {},
    data() {
        return {
            chartData: {
                datacollection: { labels: [] },
                options: {}
            }
        };
    },
    methods: {
        fillChartData() {
            var chartData = {
                datacollection: {
                    labels: [this.$i18n.t("dashboard.noDataText")],
                    datasets: [
                        {
                            data: ["1"],
                            backgroundColor: ["rgba(217,217,217,.5)"]
                        }
                    ]
                },
                options: {
                    elements: {
                        arc: {
                            borderWidth: 0
                        }
                    },
                    scales: {
                        yAxes: [],
                        xAxes: []
                    },
                    legend: {
                        display: this.legendDisplay,
                        position: this.legendPosition,
                        onClick: () => {},
                        align: this.legendAlign
                    },

                    tooltips: {
                        enabled: true,
                        mode: "single",
                        callbacks: {
                            label: function(tooltipItems, data) {
                                return;
                                // let index = tooltipItems.index;
                                // let cbData =
                                //   resultData && resultData.length > 0 ? data.datasets[0].data[index] : 0;
                                // return `${data.labels[index]}: ${cbData}`;
                            }
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    height: 200,
                    cutoutPercentage: 75,
                    rotation: this.useGuage ? 1 * Math.PI : 0.5 * Math.PI,
                    circumference: this.useGuage ? 1 * Math.PI : 2 * Math.PI,
                    title: {
                        display: this.titleDisplay,
                        text: this.chartTitle
                    }
                }
            };

            this.chartData = chartData;
        }
    },
    mounted() {
        this.fillChartData();
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/dashboard/EmptyPie.vue